export const percentStr = (p: number) => `${p}%`;

export const toId = (name: string) => {
  if (!name) return '';

  // Insert spaces between camelCase or PascalCase boundaries: "PaymentInstallment" -> "Payment Installment"
  const withSpaces = name
    // handle transitions like "myURLValue" -> "my URL Value" (acronym followed by word)
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    // handle lower-to-upper transitions: "paymentInstallment" -> "payment Installment"
    .replace(/([a-z\d])([A-Z])/g, '$1 $2');

  return withSpaces
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^\w]/g, '_');
};

export const toTitleCase = (name: string): string => {
  if (!name) return '';
  // Minimal camelCase support: insert a space between lower/digit and upper
  const spaced = name.replace(/([a-z\d])([A-Z])/g, '$1 $2');

  return spaced
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
};
